// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KCJRD","footer":"styles_footer__16PUy"};